import { ReactNode, useRef } from "react";

import { useTheme } from "@emotion/react";
import { Box, useMediaQuery } from "@mui/material";

import { HEADER_HEIGHT } from "components/Header/components/HeaderWithContext";
import { config } from "config";

import MainMenu from "./components/MainMenu";
import SubMenu from "./components/SubMenu";
import { menuDrawerStyles } from "./menuDrawer.styles";
import { useSlideMainDrawer } from "./useSlideMainDrawer";

export interface MenuDrawerProps {
  drawerMaxWidth: number;
  menuListItems?: ReactNode;
  menuOpen: boolean;
  subMenuListItems?: ReactNode;
  subMenuOpen: boolean;
}

export const MenuDrawer = ({
  drawerMaxWidth,
  menuListItems,
  menuOpen,
  subMenuListItems,
  subMenuOpen,
}: MenuDrawerProps) => {
  const theme = useTheme();
  const menuDrawerRef = useRef<HTMLDivElement>(null);
  const { showSubMenuBehindMainMenu, setShowSubMenuBehindMainMenu } =
    useSlideMainDrawer({ menuOpen, menuDrawerRef });
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const appBarHeight =
    document.getElementById(config.HEADER_ID)?.offsetHeight ?? HEADER_HEIGHT;

  const handleMenuDrawerTransitionEnd = () => {
    if (menuOpen) {
      setShowSubMenuBehindMainMenu(true);
    }
  };

  if (!menuOpen) return null;

  return (
    <Box
      data-testid="menu-drawer"
      css={menuDrawerStyles.drawerContainer({ appBarHeight })}
    >
      <SubMenu
        drawerMaxWidth={drawerMaxWidth}
        isMobile={isMobile}
        showSubMenuBehindMainMenu={showSubMenuBehindMainMenu}
        subMenuListItems={subMenuListItems}
        subMenuOpen={subMenuOpen}
      />
      <MainMenu
        ref={menuDrawerRef}
        drawerMaxWidth={drawerMaxWidth}
        isMobile={isMobile}
        menuListItems={menuListItems}
        onTransitionEnd={handleMenuDrawerTransitionEnd}
        subMenuOpen={subMenuOpen}
      />
    </Box>
  );
};
